import React, { useContext, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { AppContext } from 'stores/App'
import useLocalStorage from 'hooks/useLocalStorage'
import Label from 'components/Label'
import useUrlParams from 'hooks/useUrlParams'
import { getEntityList } from 'helpers/params'

function LabelBadges() {
  const { t } = useTranslation()
  const [state] = useContext(AppContext)
  const [storage] = useLocalStorage('local_page', '')
  const {urlParams} = useUrlParams()
  const [numFaculty, setNumFaculty] = useState(0)
  const [numInstitution, setNumInstitution] = useState(0)

  useEffect(() => {
    
    let paramsArray = [];

    /**
     * 1. If neither state or storage is set, but url parameters are, set counters based on url parameters
     * 2. If url parameters are set and storage are set but state is not, check for a diff
     *    2A. If there is a diff, use url parameters, else use storage
     * 3. If state is empty and urlParams are empty but storage are not, use storage
     * 4. Else use state
     */ 

    // .1
    if ((!storage.entityParams || storage.entityParams.length === 0) && state.entity_params.length === 0 && urlParams.length !== 0) {
      paramsArray = getEntityList(urlParams).split('|');
    }

    // .2
    if (state.entity_params === 0 && storage.entityParams?.length !== 0 && urlParams.length !== 0) {
      paramsArray = JSON.stringify(urlParams) !== JSON.stringify(storage.urlParams) ?
        getEntityList(urlParams).split('|') : storage.entityParams.split('|')
    }

    // .3
    if (state.entity_params.length === 0 && urlParams.length === 0 && storage.entityParams.length !== 0 ) {
      paramsArray = storage.entityParams.split('|')
    }

    // .4 
    if (state.entity_params.length !== 0) {
      paramsArray = state.entity_params.split('|')
    }

    let countFaculty = 0
    let countInstitution = 0
    paramsArray.forEach(param => {
      if (param.startsWith('F')) {
        countFaculty++
      } else if (param.startsWith('I')) {
        countInstitution++
      }
    })
    setNumFaculty(countFaculty)
    setNumInstitution(countInstitution)
  }, [state])

  return (
    <div className="layout__inner--dynamic">
      <Label
        modifierClasses="label--framed label--white label--badge u-mr-50"
        text={t('faculties')}
        number={numFaculty}
      />
      <Label
        modifierClasses="label--framed label--white label--badge u-mr-50"
        text={t('departments')}
        number={numInstitution}
      />
    </div>
  )
}

export default LabelBadges
